import { StyledSwitch } from './Switch.style'

export const Switch = (props) => {

	return (
		<StyledSwitch {...props} />
	)
}